import { useStytchB2BClient } from "@stytch/react/b2b";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
    const stytch = useStytchB2BClient();
    const navigate = useNavigate();

    const logout = async () => {
        try {
            await stytch.session.revoke(); // Revoke Stytch session
            localStorage.removeItem("organization_id"); // Remove stored data
            localStorage.removeItem("stytch_token"); // Remove JWT if stored
            navigate("/login"); // Redirect to login page
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };

    return logout;
};

export default useLogout;